/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeCreateComplaintRecordCommand
 */
export interface EmployeeCreateComplaintRecordCommand {
    /**
     * 
     * @type {string}
     * @memberof EmployeeCreateComplaintRecordCommand
     */
    complaintId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof EmployeeCreateComplaintRecordCommand
     */
    fileIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof EmployeeCreateComplaintRecordCommand
     */
    message: string;
}

/**
 * Check if a given object implements the EmployeeCreateComplaintRecordCommand interface.
 */
export function instanceOfEmployeeCreateComplaintRecordCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "complaintId" in value;
    isInstance = isInstance && "fileIds" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function EmployeeCreateComplaintRecordCommandFromJSON(json: any): EmployeeCreateComplaintRecordCommand {
    return EmployeeCreateComplaintRecordCommandFromJSONTyped(json, false);
}

export function EmployeeCreateComplaintRecordCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeCreateComplaintRecordCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'complaintId': json['complaintId'],
        'fileIds': json['fileIds'],
        'message': json['message'],
    };
}

export function EmployeeCreateComplaintRecordCommandToJSON(value?: EmployeeCreateComplaintRecordCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'complaintId': value.complaintId,
        'fileIds': value.fileIds,
        'message': value.message,
    };
}

